<template>
  <!-- NOTE (TEMPLATE) error page 403 "you are not allowed to view this page" -->

  <div class="app flex-row align-items-center Back ">
    <!-- NOTE (TEMPLATE) error page 403 "you are not allowed to view this page" -->

    <div class="container">
      <b-row class="justify-content-center ">
        <div class="col">
          <div style=" height: 20vh"></div>
          <div>
            <b-jumbotron>
              <template v-slot:header
                ><span class="text-secondary display-1">403</span></template>

              <template v-slot:lead>
                <h2 class="text-info">شما مجاز به مشاهده این صفحه نیستید!</h2>
              </template>

              <hr />

              <b-button variant="success" @click="goback()">صفحه ورود</b-button>
            </b-jumbotron>
          </div>
        </div>
        <!-- <p style="font-size:100px" class="text-primary">404 </p> -->

        <div class="col">
          <img src="../assets/images/403-4.gif" class="container-fluid" />
        </div>

        <!-- 
        <b-col >
           <div class="clearfix">
            <h1 class="float-left display-3 mr-4">
            404
            </h1>
            <h4 class="pt-3">برگه یافت نشد</h4>
         
            <a href="/">
              <p class="text-muted">بازگشت به خانه</p>
            </a>
          </div>
            
        </b-col>
        <b-col class="6">
          
        </b-col>
       -->
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page403",
  data() {
    return {
      role: ""
    };
  },
  methods: {
    goback() {
      // this.$router.go(-2);
      this.$router.push({
        path:
          this.role == "researcher"
            ? "/login"
            : this.role == "referee"
            ? "reflogin"
            : this.role == "university"
            ? "unilogin"
            : this.role == "manager"
            ? "adminlogin"
            : this.role == "admin"
            ? "adminlogin"
            : "",
        query: { return: this.$route.query.return }
      });
    }
  },
  mounted() {
    this.role = localStorage.getItem("role");
  }
};
</script>
<style>
.Back {
  background-color: #ffffff;
  /* background-image: url("../assets/images/resBack.png");

  background-size: cover; */
}
.jumbotron {
  background-color: #ffffff;
}
/* .responsive {
  width: 100%;
  max-width: 800px;
  height: auto;
} */
</style>
